import { css } from "@emotion/core"
import { theme } from "../constants"

export const defaultfieldText = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.fontSizes[8]};
  color: ${theme.colors.text};
`

export const tagline = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[13]};
  line-height: ${theme.lineHeights[2]};
  color: ${theme.colors.text};
`

export const taglineBold = css`
  font-weight: ${theme.fontWeights.semiBold};
  font-size: ${theme.fontSizes[13]};
  line-height: ${theme.lineHeights[2]};
  color: ${theme.colors.text};
`

export const spaceName = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.lineHeights[1]};
  line-height: ${theme.lineHeights[2]};
  color: ${theme.colors.text};
`

export const pageHeading = css`
  font-weight: ${theme.fontWeights.semiBold};
  font-size: ${theme.fontSizes[6]};
  line-height: ${theme.lineHeights[1]};
  color: ${theme.colors.text};
`

export const bodyHeading = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[6]};
  line-height: ${theme.lineHeights[1]};
  color: ${theme.colors.text};
`

export const sectionHeading = css`
  font-weight: ${theme.fontWeights.semiBold};
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.fontSizes[8]};
  color: ${theme.colors.text};
`
export const placeHolder = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.fontSizes[8]};
  color: ${theme.colors.grey[400]};
`
export const sectionTextPrimary = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.lineHeights[0]};
  color: ${theme.colors.text};
`
export const sectionTextSecondary = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.lineHeights[0]};
  color: ${theme.colors.grey[400]};
`
export const linkText = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.lineHeights[0]};
  color: ${theme.colors.purple[200]};
`
export const smallTextPrimary = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[2]};
  line-height: ${theme.fontSizes[5]};
  color: ${theme.colors.text};
`
export const smallTextSecondary = css`
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[2]};
  line-height: ${theme.fontSizes[5]};
  color: ${theme.colors.grey[400]};
`

const textTypeStyles = {
  default: defaultfieldText,
  tagline: tagline,
  taglineBold: taglineBold,
  spaceName: spaceName,
  pageHeading: pageHeading,
  bodyHeading: bodyHeading,
  sectionHeading: sectionHeading,
  placeHolder: placeHolder,
  sectionTextPrimary: sectionTextPrimary,
  sectionTextSecondary: sectionTextSecondary,
  linkText: linkText,
  smallTextPrimary: smallTextPrimary,
  smallTextSecondary: smallTextSecondary,
}

export const textStyles = (textType) => {
  return css`
    font-family: ${theme.fonts.primary};
    ${textTypeStyles[textType]};
  `
}

export const bgStyle = css`
  height: 50vh;
  width: 80vw;
  background: #493988;
  padding: 1em;
`
